import { RewardsRakebackTier } from '../interfaces/rakeback.interface';

export const REWARDS_RAKEBACK_TIERS: RewardsRakebackTier[] = [
  {
    tier: 1,
    level: {
      from: 0,
      to: 25,
    },
    chance: 0.25,
  },
  {
    tier: 2,
    level: {
      from: 25,
      to: 50,
    },
    chance: 0.5,
  },
  {
    tier: 3,
    level: {
      from: 50,
      to: 75,
    },
    chance: 0.75,
  },
  {
    tier: 4,
    level: {
      from: 75,
      to: 100,
    },
    chance: 1,
  },
  {
    tier: 5,
    level: {
      from: 100,
      to: null,
    },
    chance: 1.5,
  },
];
